import {
  FortnoxConnectUrlDto,
  FortnoxConnectionStatusDto,
  Route,
  populateRoute,
} from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"
import { request } from "../api"
import storeQueries from "./store-queries"

async function fetchFortnoxStatus(
  storeId: string,
): Promise<FortnoxConnectionStatusDto> {
  return request<FortnoxConnectionStatusDto>({
    url: populateRoute(Route.STORE__FORTNOX_STATUS, storeId),
    method: "GET",
  })
}

async function startFortnoxConnection(
  storeId: string,
): Promise<FortnoxConnectUrlDto> {
  return request<FortnoxConnectUrlDto>({
    url: populateRoute(Route.STORE__FORTNOX_CONNECT, storeId),
    method: "POST",
  })
}

async function disconnectFortnox(
  storeId: string,
): Promise<FortnoxConnectionStatusDto> {
  return request<FortnoxConnectionStatusDto>({
    url: populateRoute(Route.STORE__FORTNOX_DISCONNECT, storeId),
    method: "DELETE",
  })
}

export const fortnoxQueries = {
  all: (storeId: string) => ["fortnox", storeId],
  status: (storeId: string) =>
    queryOptions({
      queryKey: fortnoxQueries.all(storeId),
      queryFn: () => fetchFortnoxStatus(storeId),
      // Fetch fresh after returning from Fortnox's approval page.
      staleTime: 0,
    }),
}

export const useStartFortnoxConnectionMutation = (storeId: string) => {
  return useMutation({
    mutationFn: () => startFortnoxConnection(storeId),
    onSuccess: ({ url }) => {
      window.location.assign(url)
    },
  })
}

export const useDisconnectFortnoxMutation = (storeId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => disconnectFortnox(storeId),
    onSuccess: (status) => {
      queryClient.setQueryData(fortnoxQueries.all(storeId), status)
      // Disconnecting clears the store's POS type.
      queryClient.invalidateQueries({
        queryKey: storeQueries.detail(storeId).queryKey,
      })
    },
  })
}
